import { FC } from 'react';
import { Box, Button, Flex } from '@alexpireddu/map-ui';
import styled from '@emotion/styled';
import { useNavigate } from 'react-router-dom';
import icon from './404_ICON.svg';
import _ from 'lodash';

const MainWrapper = styled.div({
  display: 'inline-block',
  margin: '0 auto',
  position: 'absolute',
  left: '50%',
  top: '50%',
  transform: 'translate(-50%, -50%)',
  padding: '16px',
});

const ErrorPageImage = styled.img({
  fill: '#4F5666',
  color: '#4F5666',
  width: '200px',
  height: '200px',
  transform: 'translateX(50%)',
});

export interface NotFoundPageProps {
  details?: string;
}

const NotFoundPage: FC<NotFoundPageProps> = ({ details }) => {
  const navigate = useNavigate();

  return (
    <MainWrapper>
      <ErrorPageImage src={icon} />
      <div style={{ textAlign: 'center', marginTop: '32px' }}>
        <h2>404: La pagina non è stata trovata.</h2>
      </div>
      <Flex mt="32px" justifyContent="center">
        <Box mr="8px">
          <Button variant="secondary" onClick={() => navigate(-1)}>
            Indietro
          </Button>
        </Box>

        <Box ml="8px">
          <Button variant="primary" onClick={() => navigate('/')}>
            Torna alla schermata Home
          </Button>
        </Box>
      </Flex>
      <Box mt={'16px'}>{!_.isNil(details) && <details>{details}</details>}</Box>
    </MainWrapper>
  );
};

export default NotFoundPage;
